import {Paper} from '@mui/material';
import {styled} from '@mui/styles';
import moment from 'moment';
import React, {useCallback, useEffect, useState} from 'react';
import MonthSelector from '../../components/MonthSelector';
import Table from '../Jobs/Table';

const Holder = styled(Paper)(({theme}) => ({
  '&.MuiPaper-root': {
    marginTop: theme.spacing(2)
  }
}));

const Jobs = ({user}) => {
  const [range, setRange] = useState(null)

  const handleMonth = useCallback(month => setRange(
    {from: month.clone(), to: month.clone().endOf('month')}
  ), []);

  useEffect(() => {
    if (!range) {
      handleMonth(moment().startOf('month'));
    }
  }, [range, handleMonth]);

  return range ? (
    <Holder>
      <MonthSelector month={range.from} onSelectMonth={handleMonth}/>
      <Table
        user={user}
        tableProps={{
          canRefresh: false,
          tableProps: {
            options: {search: false, paging: false, draggable: false, pageSize: 500},
            components: {
              Container: props => <Paper elevation={0} {...props} />,
              Toolbar: () => null
            }
          }
        }}
        range={range}
        canAdd={false}
        displayTitle={false}
        showHeader={false}
        filterStatus={false}
      />
    </Holder>
  ) : null
};

export default Jobs;